import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const rochePaginationContainerCss = "roche-pagination-container{overflow-x:auto;display:flex;margin:0 auto;width:min-content;gap:1rem}roche-pagination-container span{height:2.5rem;width:2.5rem;text-align:center;line-height:2}";
const RochePaginationContainerStyle0 = rochePaginationContainerCss;

const RochePagination = /*@__PURE__*/ proxyCustomElement(class RochePagination extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
    }
    render() {
        return (h("slot", { key: '086bf71c13aff1809012362ba8d55e72130d9b02' }));
    }
    static get style() { return RochePaginationContainerStyle0; }
}, [4, "roche-pagination-container"]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-pagination-container"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-pagination-container":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RochePagination);
            }
            break;
    } });
}

const RochePaginationContainer = RochePagination;
const defineCustomElement = defineCustomElement$1;

export { RochePaginationContainer, defineCustomElement };

//# sourceMappingURL=roche-pagination-container.js.map